// extracted by mini-css-extract-plugin
export default {"root":"TherapistAddOtherCredential_root__bel04","form":"TherapistAddOtherCredential_form__67MOi","lastRow":"TherapistAddOtherCredential_lastRow__0KEhv"};